<div class="landing-page">
  <div class="position-absolute landing-container">
    <div class="col-md-5 landingleftdiv">
      <a class="img-fluid"><img src="../../../assets/images/login-page-image/Innova_logo.svg" alt="Innova_logo" /></a>
      <div class="pt-5 landing-title h3" [@revealAnimation]>
        GLOBAL SOLUTIONS DELIVERY
      </div>
      <div class="pt-2 landing-title-1" [@revealAnimation]>PORTAL</div>
      <div class="pt-2 landing-description h3" [@revealAnimation]>
        A comprehensive collection of Employee Dashboard, Skill Repository, KMS Portal, Artifactory Repository, Proposal
        Repository, Governance Portal, CMF Portal, Customer 360 Portal, RMG Portal, Which provides valuable insights to
        achieve
        specific objectives and goals of the Organization.
      </div>
    </div>

    <div class="col-md-7 landingrightdiv">
      <div class="row" style="margin-top: -5rem; margin-left: 1rem">
        <div class="col-md-4 p-2 landingcarddiv">
          <div class="card landingcard">
            <div class="card-overlay" (click)="pageNavigate('Dashboard')"
              [class.disable]="!isAuthorizedUser('Template')">
              <div class="card-details h6">

                An Employee Dashboard is a centralized online platform that provides employees with a personalized and
                real-time view of relevant information.

              </div>
              <i class="fas fa-arrow-circle-right learn-more-arrow" style="font-size: 24px"></i>
            </div>
            <img src="../../../assets/images/landing-page-icons/empdash.png" class="card-img-top" alt="Image 2" />
            <div class="card-body">
              <span class="card-title">Employee Dashboard</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2 landingcarddiv">
          <div class="card landingcard">
            <div class="card-overlay" (click)="pageNavigate('Skills')" [class.disable]="!isAuthorizedUser('Skill')">
              <div class="card-details h6">
                Skill repository is a comprehensive list of all the experiences,
                professional skills of employees in an organization.
              </div>
              <i class="fas fa-arrow-circle-right learn-more-arrow" style="font-size: 24px"></i>
            </div>
            <img src="../../../assets/images/landing-page-icons/SkillRepository.png" class="card-img-top"
              alt="Image 6" />
            <div class="card-body">
              <span class="card-title">Skill Repository</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2 landingcarddiv">
          <div class="card landingcard" [class.disabled]="accessForKMS">
            <div class="card-overlay" (click)="pageNavigate('Sales')">
              <div class="card-details h6">
                KMS Portal is a centralized online platform designed to systematically capture and distribute an
                organization's collective knowledge and information.
              </div>
              <i class="fas fa-arrow-circle-right learn-more-arrow" style="font-size: 24px"></i>
            </div>
            <img src="../../../assets/images/landing-page-icons/kmp.png" class="card-img-top" alt="Image 5" />
            <div class="card-body">
              <span class="card-title">KMS Portal</span>
            </div>
          </div>
        </div>

        <div class="col-md-4 p-2 landingcarddiv">
          <div class="card landingcard">
            <div class="card-overlay" (click)="pageNavigate('Templates')"
              [class.disable]="!isAuthorizedUser('Template')">
              <div class="card-details h6">
                Artifactory Repository is a centralized system designed for managing and storing artifacts and other
                software components within a software development ecosystem.
              </div>
              <i class="fas fa-arrow-circle-right learn-more-arrow" style="font-size: 24px"></i>
            </div>
            <img src="../../../assets/images/landing-page-icons/Tempaltes.png" class="card-img-top" alt="Image 2" />
            <div class="card-body">
              <span class="card-title">Artifactory Repository</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2 landingcarddiv">
          <div class="card landingcard">
            <div class="card-overlay" (click)="pageNavigate('Proposals')">
              <div class="card-details h6">

                Proposal Repository is a centralized and organized system designed to store, manage, and retrieve
                proposals within an organization.
              </div>
              <i class="fas fa-arrow-circle-right learn-more-arrow" style="font-size: 24px"></i>
            </div>
            <img src="../../../assets/images/landing-page-icons/Proposals.png" class="card-img-top" alt="Image 5" />
            <div class="card-body">
              <span class="card-title">Proposal Repository</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2 landingcarddiv">
          <div class="card landingcard">
            <img src="../../../assets/images/early-preview.png" class="Card-early" alt="Image 5">
            <div class="card-overlay" (click)="pageNavigate('executiveDashboard')">
              <div class="card-details h6">
                An extensive suite comprising the Executive Dashboard, RMG Dashboard, Sales Pipeline, Presales Dashboard
                and GSD Review Report
              </div>
              <i class="fas fa-arrow-circle-right learn-more-arrow" style="font-size: 24px"></i>
            </div>
            <img src="../../../assets/images/landing-page-icons/GovernanceNewIcon.png" class="card-img-top"
              alt="Image 5" />
            <div class="card-body">
              <span class="card-title">Executive Dashboard</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2 landingcarddiv">
          <div class="card landingcard" [class.disabled]="accessForCMF">
            <div class="card-overlay" (click)="pageNavigate('Competencies')">
              <div class="card-details h6">
                CMF Portal displays the service level maturity of the individual contributors with respect to the
                Competency.
              </div>
              <i class="fas fa-arrow-circle-right learn-more-arrow" style="font-size: 24px"></i>
            </div>
            <img src="../../../assets/images/landing-page-icons/Competency.png" class="card-img-top" alt="Image 5" />
            <div class="card-body">
              <span class="card-title">CMF Portal</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 p-2 landingcarddiv">
          <div class="card landingcard">
            <div class="card-overlay" onclick="window.open('https://dmd.innovasolutions.com', '_blank')">
              <div class="card-details h6">
                Delivery Manager Dashboard, shortly known as DMD, is an in-house built Dashboarding portal to track the
                health status of projects and present the Red-Amber-Green (RAG) dashboard.
              </div>
              <i class="fas fa-arrow-circle-right learn-more-arrow" style="font-size: 24px"></i>
            </div>
            <img src="../../../assets/images/landing-page-icons/ict.png" class="card-img-top" alt="Image 5" />
            <div class="card-body">
              <span class="card-title">DMD Portal</span>
            </div>
          </div>
        </div>

        <div class="col-md-4 p-2 landingcarddiv">
          <div class="card landingcard">
            <div class="card-overlay" onclick="window.open('https://epas.innovasolutions.com/')">
              <div class="card-details h6">
                ePAS is an in-house built Project and Resource allocation system that tracks all global projects of
                Innova solutions and entire lifecycle of the project from creation to closure.
              </div>
              <i class="fas fa-arrow-circle-right learn-more-arrow" style="font-size: 24px"></i>
            </div>
            <img src="../../../assets/images/landing-page-icons/PPM.png" class="card-img-top" alt="Image 5" />
            <div class="card-body">
              <span class="card-title">PPM Portal</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>